import { apiClient, ApiError, getAuthToken } from '@/shared/data/client';
import type { DiagnosticsReportDto } from '@flowqa/shared';

type DiagnosticsReportApi = Omit<DiagnosticsReportDto, 'timestamp'> & { timestamp: string | Date };

const mapDiagnosticsReport = (report: DiagnosticsReportApi): DiagnosticsReportDto => ({
  ...report,
  timestamp: report.timestamp instanceof Date ? report.timestamp : new Date(report.timestamp),
});

const ensureToken = (tokenOverride?: string | null): string => {
  const token = tokenOverride ?? getAuthToken();
  if (!token) {
    throw new ApiError('Not authenticated');
  }
  return token;
};

export const fetchDiagnosticsReport = async (
  tokenOverride?: string | null,
): Promise<DiagnosticsReportDto> => {
  const token = ensureToken(tokenOverride);
  const report = await apiClient.get<DiagnosticsReportApi>('superuser/diagnostics', { token });
  return mapDiagnosticsReport(report);
};
